/* istanbul ignore file */

import { useEffect } from "react";
import { useDispatch } from "react-redux"
import { logInIfRequired, checkAuthorization } from '../redux/actions/userManagementActions';



//This hook should be used on all pages which require the user to be logged in

export const useLogInIfRequired = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        setTimeout(() => dispatch(logInIfRequired()), 750);
    }, [dispatch])
}

// This hook is used if we need to fetch a token to make an API call for data 
// Which we don't want to be stored in the redux store
export const useAuthCheck = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        setTimeout(() => dispatch(checkAuthorization()), 1500);
    }, [dispatch])
}